export const AppConfig = Object.freeze({
    DOMAIN: import.meta.env.VITE_APP_API_URL,
    API_DOMAIN: import.meta.env.VITE_APP_API_URL + "api",
});